import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { read as getPins, readPins } from 'next/entities/pins';
import { readTags, Shape as TagShape } from 'next/entities/tags';
import { Shape as PinShape } from 'next/entities/experiences';
import { asRequest } from 'next/entities/requests';
import {
  H1,
  Page,
  PageActions,
  PageBody,
  PageHeader,
  PageTitle,
} from 'next/components/ui';
import { Loading } from 'next/components/Listing';
import NewPinManager from './NewPinManager';
import PinsMoreMenu from './PinsMoreMenu';
import PinsList from './PinsList';

/**
 * TODO: Consider consolidating with flow listing page when moving pin page
 *       components to the `/pages` directory
 */

export const PinsPage = ({ onLoad, pins = {}, tags = {} }) => {
  useEffect(() => {
    onLoad?.();
  }, [onLoad]);

  const { loading: loadingPins = true } = pins;
  const { loading: loadingTags = true } = tags;

  const loading = loadingPins || loadingTags;
  return (
    <Page>
      <PageHeader>
        <PageTitle>
          <H1>Pins</H1>
        </PageTitle>

        <PageActions>
          <PinsMoreMenu />
          <NewPinManager />
        </PageActions>
      </PageHeader>

      <PageBody>
        {loading && <Loading />}

        {!loading && <PinsList pins={pins.data} tags={tags.data} />}
        {/* TODO: Handle error state */}
      </PageBody>
    </Page>
  );
};

PinsPage.propTypes = {
  pins: asRequest(PropTypes.objectOf(PinShape)),
  tags: asRequest(PropTypes.objectOf(TagShape)),
  onLoad: PropTypes.func,
};

const mapStateToProps = state => ({
  pins: readPins(state),
  tags: readTags(state),
});

const mapDispatchToProps = {
  onLoad: getPins,
};

export default connect(mapStateToProps, mapDispatchToProps)(PinsPage);
